const PostMessageTypes = {
  ADD_ALERT: 'UI_ADDON_AUTOMATION_ADD_ALERT',
  ADD_CONTROL: 'UI_ADDON_AUTOMATION_ADD_CONTROL',
  APP_LOADED: 'UI_ADDON_AUTOMATION_APP_LOADED',
  APP_LOADED_ANALYTICS: 'UI_ADDON_AUTOMATION_APP_LOADED_ANALYTICS',
  CLOSE_ANY_OPEN_EMBED_SIDE_PANEL: 'UI_ADDON_AUTOMATION_CLOSE_ANY_OPEN_EMBED_SIDE_PANEL',
  CLOSE_ANY_OPEN_SIMPLE_CONFIG_PANEL: 'UI_ADDON_AUTOMATION_CLOSE_ANY_OPEN_SIMPLE_CONFIG_PANEL',
  CLOSE_SIDEPANEL: 'UI_ADDON_AUTOMATION_CLOSE_SIDEPANEL',
  CONFIG_CONTAINER_LOADED: 'UI_ADDON_AUTOMATION_CONFIG_CONTAINER_LOADED',
  EMBEDDED_FLOW_LOADED: 'UI_ADDON_AUTOMATION_EMBEDDED_FLOW_LOADED',
  ERROR: 'UI_ADDON_AUTOMATION_ERROR',
  FLOW_CREATED_BUTTON_CLICKED: 'UI_ADDON_AUTOMATION_FLOW_CREATED_BUTTON_CLICKED',
  FLOW_UPDATED: 'UI_ADDON_AUTOMATION_FLOW_UPDATED',
  FULL_SCREEN_SIDE_PANEL: 'UI_ADDON_AUTOMATION_FULL_SCREEN_SIDE_PANEL',
  IS_CONFIG_CONTAINER_LOADED: 'UI_ADDON_AUTOMATION_IS_CONFIG_CONTAINER_LOADED',
  NAVIGATE_TO_WORKFLOWS_APP: 'UI_ADDON_AUTOMATION_NAVIGATE_TO_WORKFLOWS_APP',
  NEW_FLOW_CREATED: 'UI_ADDON_AUTOMATION_NEW_FLOW_CREATED',
  // currently unused
  NEW_UUID_FLOW_CREATED: 'UI_ADDON_AUTOMATION_NEW_UUID_FLOW_CREATED',
  // currently unused
  NEW_MULTI_FLOW_CREATED: 'UI_ADDON_AUTOMATION_NEW_MULTI_FLOW_CREATED',
  NEW_MULTI_UUID_FLOW_CREATED: 'UI_ADDON_AUTOMATION_NEW_MULTI_UUID_FLOW_CREATED',
  OPEN_SIMPLE_SIDE_PANEL: 'UI_ADDON_AUTOMATION_OPEN_SIMPLE_SIDE_PANEL',
  REFRESH_FLOW: 'UI_ADDON_AUTOMATION_REFRESH_FLOW',
  REFRESH_SIDEPANEL_FLOW_DATA: 'UI_ADDON_AUTOMATION_REFRESH_SIDEPANEL_FLOW_DATA',
  RENDER_MULTI_FLOWS: 'UI_ADDON_AUTOMATION_RENDER_MULTI_FLOWS',
  RESIZE_SIDE_PANEL: 'RESIZE_SIDE_PANEL',
  REQUEST_MULTI_FLOWS: 'UI_ADDON_AUTOMATION_REQUEST_MULTI_FLOWS',
  SELECT_ACTION: 'UI_ADDON_AUTOMATION_SELECT_ACTION',
  SELECT_SIMPLE_AUTOMATION_ACTION_BY_FLOW_ID: 'UI_ADDON_AUTOMATION_SELECT_SIMPLE_AUTOMATION_ACTION_BY_FLOW_ID',
  SELECT_SIMPLE_AUTOMATION_ACTION_BY_UUID: 'UI_ADDON_AUTOMATION_SELECT_SIMPLE_AUTOMATION_ACTION_BY_UUID',
  SET_CTA_URL: 'UI_ADDON_AUTOMATION_SET_CTA_URL',
  SET_EMBED_ORIGIN_URL_SESSION_STORAGE_KEY: 'UI_ADDON_AUTOMATION_SET_EMBED_ORIGIN_URL_SESSION_STORAGE_KEY',
  SET_UNIQUE_ID: 'UI_ADDON_AUTOMATION_SET_UNIQUE_ID',
  SET_CONTEXTUAL_EMBED_INFO: 'UI_ADDON_AUTOMATION_SET_CONTEXTUAL_EMBED_INFO',
  SET_UPGRADE_MODAL_KEY: 'SET_UPGRADE_MODAL_KEY',
  SIMPLE_CONFIG_PANEL_ERROR: 'UI_ADDON_AUTOMATION_SIMPLE_CONFIG_PANEL_ERROR',
  UNDO_FULL_SCREEN_SIDE_PANEL: 'UI_ADDON_AUTOMATION_UNDO_FULL_SCREEN_SIDE_PANEL'
};
export const PostMessageTypesValues = Object.keys(PostMessageTypes).map(type => PostMessageTypes[type]);
export default PostMessageTypes;